(function(){

    document.addEventListener('click', function(e){
        const btn = e.target.closest('.yt-facade__btn');
        if(!btn) return;

        const wrap = btn.closest('.yt-facade');
        const id = wrap && wrap.dataset.ytid;
        if(!id) return;

        // Parametri supportati: controls, rel, iv_load_policy, playsinline, autoplay, fs, ecc.
        // (Alcuni vecchi parametri tipo showinfo e modestbranding sono deprecati/non affidabili)
        const src = "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(id) + "?autoplay=1&playsinline=1&rel=0&iv_load_policy=3&controls=1";

        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', src);
        iframe.setAttribute('title', 'YouTube video player');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen', '');
        iframe.style.width = "100%";
        iframe.style.height = "100%";

        // Importante: niente overlay sopra al player una volta caricato (policy)
        wrap.innerHTML = "";
        wrap.appendChild(iframe);
    });


    /*
    * Inizializzazione Swiper.js
    * */
    var swiper = new Swiper(".photoSwiper", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            "992": {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            "1200": {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
    });

    var swiper = new Swiper(".videoSwiper", {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            "992": {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            "1200": {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
    });

    var swiper = new Swiper(".newsSwiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
            },
            "992": {
                slidesPerView: 3,
            },
            "1200": {
                slidesPerView: 3,
            },
        },
    });

    var swiper = new Swiper(".partnershipSwiper", {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
            },
            "992": {
                slidesPerView: 3,
            },
            "1200": {
                slidesPerView: 4,
            },
        },
    });


    /*
    * Apertura modale Photogallery
    * */
    (function initPhotoModal() {
        const photoModal = document.getElementById('dlpPhotoModal');
        const photoImgEl = document.getElementById('dlpPhotoImg');
        const photoCurEl = document.getElementById('dlpPhotoCurrent');
        const photoTotEl = document.getElementById('dlpPhotoTotal');

        if (!photoModal || !photoImgEl) return;

        const photoTriggers = Array.from(document.querySelectorAll('.js-photo-trigger'));
        if (!photoTriggers.length) return;

        let photoIndex = 0;

        const preloadPhoto = (i) => {
            const tr = photoTriggers[i];
            if (!tr) return;
            const src = tr.getAttribute('data-src');
            if (!src) return;
            const im = new Image();
            im.src = src;
        };

        const showPhoto = (i) => {
            const len = photoTriggers.length;
            photoIndex = (i + len) % len;

            const tr = photoTriggers[photoIndex];
            const src    = tr.getAttribute('data-src') || '';
            const alt    = tr.getAttribute('data-alt') || '';
            const srcset = tr.getAttribute('data-srcset') || '';
            const sizes  = tr.getAttribute('data-sizes') || '';
            const w      = tr.getAttribute('data-w') || '';
            const h      = tr.getAttribute('data-h') || '';

            photoImgEl.src = src;
            photoImgEl.alt = alt;

            if (srcset) photoImgEl.setAttribute('srcset', srcset); else photoImgEl.removeAttribute('srcset');
            if (sizes)  photoImgEl.setAttribute('sizes', sizes);   else photoImgEl.removeAttribute('sizes');
            if (w) photoImgEl.setAttribute('width', w); else photoImgEl.removeAttribute('width');
            if (h) photoImgEl.setAttribute('height', h); else photoImgEl.removeAttribute('height');

            if (photoCurEl) photoCurEl.textContent = String(photoIndex + 1);
            if (photoTotEl) photoTotEl.textContent = String(len);

            preloadPhoto((photoIndex + 1) % len);
            preloadPhoto((photoIndex - 1 + len) % len);
        };

        const openPhoto = (i) => {
            showPhoto(i);
            photoModal.hidden = false;
            document.documentElement.classList.add('dlp-modal-open');
        };

        const closePhoto = () => {
            photoModal.hidden = true;
            document.documentElement.classList.remove('dlp-modal-open');

            photoImgEl.removeAttribute('srcset');
            photoImgEl.removeAttribute('sizes');
            photoImgEl.removeAttribute('width');
            photoImgEl.removeAttribute('height');
            photoImgEl.src = '';
            photoImgEl.alt = '';
        };

        document.addEventListener('click', (e) => {
            const trigger = e.target.closest('.js-photo-trigger');
            if (trigger) {
                e.preventDefault();
                const i = parseInt(trigger.getAttribute('data-index') || '0', 10);
                openPhoto(Number.isFinite(i) ? i : 0);
                return;
            }

            // chiusura SOLO se clicco dentro la photo modal
            if (!photoModal.hidden && e.target.closest('#dlpPhotoModal') && e.target.matches('[data-close]')) {
                e.preventDefault();
                closePhoto();
                return;
            }

            if (!photoModal.hidden && e.target.matches('[data-next]')) {
                e.preventDefault();
                showPhoto(photoIndex + 1);
                return;
            }

            if (!photoModal.hidden && e.target.matches('[data-prev]')) {
                e.preventDefault();
                showPhoto(photoIndex - 1);
                return;
            }
        });

        document.addEventListener('keydown', (e) => {
            if (photoModal.hidden) return;
            if (e.key === 'Escape') closePhoto();
            if (e.key === 'ArrowRight') showPhoto(photoIndex + 1);
            if (e.key === 'ArrowLeft') showPhoto(photoIndex - 1);
        });
    })();



    /*
    * Apertura modale Videogallery
    * */
    (function initVideoModal() {
        const videoModal = document.getElementById('dlpVideoModal');
        const videoFrame = document.getElementById('dlpVideoFrame');
        if (!videoModal || !videoFrame) return;

        const toYouTubeEmbed = (url) => {
            try {
                const u = new URL(url, window.location.href);
                let id = '';

                if (u.hostname.includes('youtu.be')) {
                    id = u.pathname.replace('/', '').split('/')[0];
                } else if (u.searchParams.get('v')) {
                    id = u.searchParams.get('v');
                } else if (u.pathname.includes('/embed/')) {
                    id = u.pathname.split('/embed/')[1].split('/')[0];
                } else if (u.pathname.includes('/shorts/')) {
                    id = u.pathname.split('/shorts/')[1].split('/')[0];
                }

                id = (id || '').replace(/[^a-zA-Z0-9_-]/g, '');
                if (!id) return '';

                const params = new URLSearchParams({
                    autoplay: '1',
                    rel: '0',
                    modestbranding: '1',
                    playsinline: '1',
                });

                return `https://www.youtube-nocookie.com/embed/${id}?${params.toString()}`;
            } catch {
                return '';
            }
        };

        const openVideo = (url) => {
            const embed = toYouTubeEmbed(url);
            if (!embed) return;

            videoFrame.src = embed;
            videoModal.hidden = false;
            document.documentElement.classList.add('dlp-modal-open');
        };

        const closeVideo = () => {
            videoFrame.src = '';
            videoModal.hidden = true;
            document.documentElement.classList.remove('dlp-modal-open');
        };

        document.addEventListener('click', (e) => {
            const trigger = e.target.closest('.js-video-trigger');
            if (trigger) {
                e.preventDefault();
                openVideo(trigger.getAttribute('data-video-url') || '');
                return;
            }

            // chiusura SOLO se clicco dentro la video modal
            if (!videoModal.hidden && e.target.closest('#dlpVideoModal') && e.target.matches('[data-close]')) {
                e.preventDefault();
                closeVideo();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !videoModal.hidden) closeVideo();
        });
    })();

})();
